
import MonitorRecorder from "../../../assets/duotone/MonitorRecorder.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function MonitorRecorderIcon({ className, dataTestid = "MonitorRecorderIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <MonitorRecorder data-testid={dataTestid} className={classes} {...rest} />
  );
}
